import tree from "../../../components/tree.vue";
import iTable from "../../../components/Table.vue";
import IPagination from "../../../components/demo.vue";
import imgOn from "../../../assets/images/on.png";

export default {
    components: { tree, iTable, IPagination },
    data() {
        return {
            isCollapse: false,
            stateArrow: true,
            isSearch: true,
            carId: '',
            height: '320',
            list: [],
            option: {
                stripe: true,
                border: true,
                loading: false,
                highlightCurrentRow: false,
                height: false,
                mutiSelect: false,
                serialNumber: false,
            },
            columns: [
                {
                    prop: "carId",
                    label: this.$t('common.carId'),
                    align: "center",
                },
                {
                    prop: "onoffState",
                    label: this.$t('OTAManagement.state'),
                    align: "center",
                    render: (h, params) => {
                        return h('el-tag', {
                            props: { type: params.row.onoffState === '' ? '' : params.row.onoffState === 1 ? 'success' : 'info' }
                        }, params.row.onoffState === '' ? '' : params.row.onoffState === 1 ? this.$t('VehicleManagement.on') : this.$t('VehicleManagement.off'))
                    }
                },
            ],
            operates: {
                width: 100,
                fixed: "right",
                list: [
                ],
            },
            currentPage: 1,
            pageSize: 10,
            total: 1,
            map: {},
            mapLoading: false,
            carOptions: [],
            view: '',
            mapZoom: '',
            centerPoint: '',
        }
    },
    created() {

    },
    mounted() {
        this.map = new BMapGL.Map('allmap');
        this.map.setMapStyleV2({
            styleId: ''
        });
        this.map.centerAndZoom(new BMapGL.Point(117.3, 31.8), 5);
        // 设置越南中心点和视图级别
        // const vietnamCenter = new BMapGL.Point(108.2029, 15.8801)
        // this.map.centerAndZoom(vietnamCenter, 12);
        // const bounds = new BMap.Bounds(
        //    new BMap.Point(102.144, 8.576),
        //    new BMap.Point(109.469, 23.394)
        // )
        // map.setMaxBounds(bounds);
        this.map.addControl(new BMapGL.MapTypeControl({
            mapTypes: [
                BMAP_NORMAL_MAP,
                BMAP_HYBRID_MAP
            ]
        }));
        this.map.addControl(new BMapGL.ScaleControl({
            anchor: BMAP_ANCHOR_BOTTOM_RIGHT,
        }));
        this.map.addControl(new BMapGL.ZoomControl({
            anchor: BMAP_ANCHOR_BOTTOM_RIGHT,
        }));
        this.map.enableScrollWheelZoom(true);
    },
    methods: {
        toggleSideBar() {
            this.isCollapse = !this.isCollapse
            this.$store.dispatch('menuTab/toggleSideBar', this.isCollapse)
        },
        changeArrow() {
            this.stateArrow = !this.stateArrow
        },
        getData() {
            let param = {
                orgId: this.id,
                selectType: 0,
                lngLatType: 1,
            }
            this.$store.dispatch('VehicleDistribution/GET_SELECTCARLOCATIONLIST', param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.carOptions = res.data.data
                        var arr = [];
                        this.carOptions.map((item) => {
                            var point = new BMapGL.Point(item.longitude, item.latitude);
                            arr.push(point);
                        });
                        let view = this.map.getViewport(eval(arr));
                        let mapZoom = view.zoom;
                        let centerPoint = view.center;
                        this.map.centerAndZoom(centerPoint, mapZoom);
                        this.initMap()
                    }
                }
            }).catch(err => { })
        },
        initMap() {
            var imgOnPic = new Image()
            imgOnPic.src = imgOn
            this.carOptions.map((item, index) => {
                var icon = new BMapGL.Icon(imgOnPic, new BMapGL.Size(35, 32), {
                    anchor: new BMapGL.Size(10, 30)
                });
                var points = new BMapGL.Point(item.longitude, item.latitude);
                var markers = new BMapGL.Marker(points, { icon: icon });
                this.map.addOverlay(markers);
                this.openInfo(markers, points, item, 'init')
            })
        },
        openInfo(markers, points, item, type) {
            var opts = {
                width: 300,
                height: 320,
            };
            var infoWindow = new BMapGL.InfoWindow(
                this.$t('common.carId') + ':' + item.carId + "<br />" +
                this.$t('common.customNum') + ':' + item.customNum + "<br />" +
                this.$t('common.manufactureNum') + ':' + item.manufactureNum + "<br />" +
                this.$t('common.terminalId') + ':' + item.terminalId + "<br />" +
                this.$t('common.orgName') + ':' + item.orgName + "<br />" +
                this.$t('common.messageTime') + ':' + item.messageTime + "<br />" +
                this.$t('common.province') + ':' + item.province + "<br />" +
                this.$t('common.city') + ':' + item.city + "<br />" +
                this.$t('common.address') + ':' + item.address + "<br />",
                opts
            );
            if (type == 'init') {
                markers.addEventListener('click', function () {
                    this.map.openInfoWindow(infoWindow, points);
                    this.map.centerAndZoom(new BMapGL.Point(item.longitude, item.latitude), 18);
                });
            } else {
                this.map.openInfoWindow(infoWindow, points);
            }
        },
        initQuery(item) {
            this.id = item.id
            this.name = item.name
            this.map.clearOverlays()
            this.getListElectronicFence()
            this.getData()
        },
        nodeClick(val) {
            this.id = val.label
            this.name = val.value
            this.map.clearOverlays()
            this.getListElectronicFence()
            this.getData()
        },

        getListElectronicFence() {
            let param = {
                orgId: this.id,
                pageNum: this.currentPage,
                pageSize: this.pageSize,
                carId: this.carId,
            }
            this.$store.dispatch('VehicleDistribution/GET_SELECTCARSTATE', param).then(res => {
                if (res) {
                    console.log(res)
                    if (res.data.code == 200) {
                        this.list = res.data.data.list
                        this.$refs.page.CommandTotal = res.data.data.total
                    }
                }
            }).catch(err => { })
        },
        rowClick(row) {
            console.log(row)
            var imgOnPic = new Image()
            imgOnPic.src = imgOn
            var icon = new BMapGL.Icon(imgOnPic, new BMapGL.Size(35, 32), {
                anchor: new BMapGL.Size(10, 30)
            });
            var points = new BMapGL.Point(row.longitude, row.latitude);
            var markers = new BMapGL.Marker(points, { icon: icon });
            this.map.addOverlay(markers);
            this.map.centerAndZoom(points, 18);
            this.openInfo(markers, points, row, 'leftClick')
        },

        onkeyUp() {
            this.pageNum = 1
            this.getListElectronicFence()
        },
        changeSize(item) {
            this.pageSize = item.pageSize
            this.currentPage = item.pageNum
            this.getListElectronicFence();
        },

        onResize: function (x, y, width, height) {
            let box = document.getElementById("leftBox");
            box.style.width = width + "px";
        },
    }
}